


























































import _ from 'lodash';
import axios from 'axios';

import {
  Component,
  Mixins, Prop,
} from 'vue-property-decorator';

import {
  like, and,
} from '@/classes/pimcore-filtering/Filters';
import FilterBuilder from '@/classes/pimcore-filtering/FilterBuilder';
import EntityHelperMixin from '@/mixins/EntityHelperMixin';

import { ratesEndpoints } from '@/utils/config';

import EntityCrud from '@/classes/EntityCrud';
import { CrudOperation } from '@/types/CrudOperation';
import ObjectFieldNormalizer from '@/classes/normalizers/field-normalizers/ObjectFieldNormalizer';
import { FetchPolicy } from 'apollo-client/core/watchQueryOptions';

import {
  WorkTypeModel,
  defaultWorkType,
  defaultTableList,
  defaultTable,
} from '@/components/RatesPage/types';
import EntityFilter from '@/components/Entity/EntityFilter.vue';
import CustomSelect from '@/components/FormBuilder/CustomSelect.vue';
import WorkTypeItem from '@/components/RatesPage/WorkTypeItem.vue';

@Component({
  components: {
    EntityFilter,
    CustomSelect,
    WorkTypeItem,
  },
})
export default class RatesPage extends Mixins(EntityHelperMixin) {
  @Prop({
    type: String,
    required: false,
    default: 'Rates',
  }) readonly localStoragePrefix!: string

  workTypes: Array<WorkTypeModel> = [_.cloneDeep(defaultWorkType)];

  workTypesLoading = false;

  workTypesTemp: Array<WorkTypeModel> = [_.cloneDeep(defaultWorkType)];

  entityCrud: EntityCrud = new EntityCrud('Work', this.$apollo);

  objectFieldNormalizer = new ObjectFieldNormalizer();

  filters: Record<string, string> = {
    platform: '',
    client: '',
  };

  loadedFilterCount = 0;

  initialized = false;

  beforeMount() {
    this.workTypesTemp = [];
  }

  filterLoaded() {
    this.loadedFilterCount += 1;

    if (
      !this.initialized
      && this.loadedFilterCount > 0
      && this.loadedFilterCount === 2
    ) {
      this.initialized = true;
      this.searchWorkTypes();
    }
  }

  get searchAllowed() {
    const {
      platform,
      client,
    } = this.filters;
    return !!(platform && client);
  }

  async searchWorkTypes(fetchPolicy: FetchPolicy = 'cache-first') {
    const {
      platform,
      client,
    } = this.filters;
    if (!this.searchAllowed) {
      this.workTypes = [];
      return;
    }
    this.workTypesLoading = true;
    const workTypes = await this.loadWorkTypes(platform, client, fetchPolicy);

    if (workTypes?.length) {
      /** TODO [m.kudryashov 15.04.2023 - 12:20]:
      * переименовать loadRatesTables, потому что теперь возвращает не только таблицы рейтов
      */
      const allWorkRates = await this.loadRatesTables(workTypes.map((v: WorkTypeModel) => v.id.toString()));
      this.workTypes = workTypes.map((v: any) => {
        // все рейты работ по текущему, итерируемому типу работы
        let workRates = allWorkRates.find((v_rt: any) => v_rt.workTypeId.toString() === v.id.toString());
        const isSheetsEmpty = !workRates?.sheets?.length;
        if (isSheetsEmpty) {
          workRates = {
            sheets: [{
              cells: _.cloneDeep(defaultTable),
              key: Math.random().toString().substring(2),
              suppliers: [],
            }],
          };
        }

        return {
          ...v,
          rateTableCreated: !isSheetsEmpty,
          sheets: workRates.sheets,
        };
      });
    } else {
      this.workTypes = [];
    }
    this.workTypesLoading = false;
  }

  async loadRatesTables(workTypesIds: Array<string>) {
    const params = new URLSearchParams();
    params.append('workTypeId', workTypesIds.join(','));
    const resp = await axios.get(ratesEndpoints.getRatesTables, {
      params,
    });

    return resp.data;
  }

  async loadWorkTypes(platform: string, client: string, fetchPolicy: FetchPolicy = 'cache-first') {
    const filterBuilder = new FilterBuilder();
    filterBuilder.addFilters(
      and(
        and(
          like('platform__id', platform),
        ),
        and(
          like('client__id', client),
        ),
      ),
    );
    return this.loadEntityListing('Work', {
      filter: filterBuilder.build(),
    }, fetchPolicy);
  }

  filterChange(name: string, value: string) {
    this.filters[name] = value;
    this.workTypesTemp = [];
  }

  addWorkType(): void {
    if (!this.searchAllowed) {
      return;
    }
    const {
      platform,
      client,
    } = this.filters;
    this.workTypesTemp.splice(0, 0, {
      ..._.cloneDeep(defaultWorkType),
      sheets: [{
        cells: _.cloneDeep(defaultTable),
        key: Math.random().toString().substring(2),
        suppliers: [],
      }],
      tempId: Date.now(),
      platform: {
        id: platform,
      },
      client: {
        id: client,
      },
    });
  }

  copyWorkType(workType: WorkTypeModel): void {
    delete workType.id;
    this.workTypesTemp.splice(0, 0, {
      ..._.cloneDeep(workType),
      tempId: Date.now(),
    });
  }

  async workItemAction(action: CrudOperation, workType: WorkTypeModel) {
    const rateTable = workType.sheets;
    const {
      id,
      name,
      platform,
      client,
      cost_center,
      CostAccount,
      work_billing_type,
      units,
      standard,
    } = workType;
    const builtWorkType = {
      name: name.trim(),
      platform: this.objectFieldNormalizer.normalize(platform),
      client: this.objectFieldNormalizer.normalize(client),
      cost_center: this.objectFieldNormalizer.normalize(cost_center),
      CostAccount: this.objectFieldNormalizer.normalize(CostAccount),
      work_billing_type: this.objectFieldNormalizer.normalize(work_billing_type),
      units: this.objectFieldNormalizer.normalize(units),
      standard: standard || '',
    };
    let workTypeId = id;

    try {
      this.workTypesLoading = true;
      let responseWorkType: any = null;
      let responseRatesTable: any = null;
      if (action === CrudOperation.create) {
        responseWorkType = await this.entityCrud.create({
          input: builtWorkType,
          key: builtWorkType.name,
          folderPath: `/FMLHR/Виды работ/${platform?.name}/${client?.legal_name}`,
        });
        if (!responseWorkType?.success) {
          throw new Error('Ошибка создания. Проверьте наличие папок в PimCore -> Виды работ');
        }
        workTypeId = responseWorkType.message.split(': ')[1];
        responseRatesTable = await axios.post(ratesEndpoints.createRatesTable, {
          workTypeId,
          sheet: rateTable,
        });
        this.workTypesTemp = this.workTypesTemp.filter((v: WorkTypeModel) => v.tempId !== workType.tempId);
      }

      if (action === CrudOperation.update) {
        responseWorkType = await this.entityCrud.update(workTypeId, builtWorkType);
        responseRatesTable = await axios.put(ratesEndpoints.updateRatesTable, {
          workTypeId,
          sheet: rateTable,
        });
      }

      if (action === CrudOperation.delete) {
        if (!workTypeId) {
          this.workTypesTemp = this.workTypesTemp.filter((v: WorkTypeModel) => v.tempId !== workType.tempId);
          return;
        }
        responseWorkType = await this.entityCrud.delete(workTypeId);
        const params = new URLSearchParams();
        params.append('workTypeId', workTypeId.toString());
        await axios.delete(ratesEndpoints.deleteRatesTable, {
          params,
        });
      }
      await this.searchWorkTypes('network-only');
      if (!responseWorkType || !responseWorkType.success) {
        throw new Error(responseWorkType?.message);
      }
      this.workTypesLoading = false;
    } catch (e) {
      this.$bus.$emit('notification', `${action}, ${e}`, 'error');
      this.workTypesLoading = false;
    }
  }
}

